import ReportsView from '../../pages/ReportsView';

// Nome simples (PT): Página de Relatórios
export default function PaginaRelatorios(props) {
  return <ReportsView {...props} />;
}






